<div class="td-wb-modal-notification">
  <h1 class="td-wb-modal-notification__header"
      translate="tdWb.modalNotification.drips.TITLE"></h1>
  <div class="td-wb-modal-notification__row">
    <div class="td-wb-modal-notification__left">
      <p class="td-wb-modal-notification__copy"
         translate="tdWb.modalNotification.drips.DESCRIPTION"></p>
      <div>
        <ul class="td-wb-ul td-wb-ul--basic td-wb-modal-notificiation__list">
          <li translate="tdWb.modalNotification.drips.DETAILS_I"></li>
          <li translate="tdWb.modalNotification.drips.DETAILS_II"></li>
          <li translate="tdWb.modalNotification.drips.DETAILS_III"></li>
        </ul>
      </div>
      <a class="td-wb-modal-notification__link"
         tdWbHref="link_dividends_new_user"
         translate="tdWb.modalNotification.drips.LEARN_MORE"></a>
    </div>
    <div class="td-wb-modal-notification--image-container">
      <img tdWbModalNotificationImage
           width="180px"
           height="180px"
           src="drips.svg"
           [attr.alt]="'tdWb.modalNotification.drips.TITLE' | translate" />
    </div>
  </div>
</div>
